// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// Services
import { SystemApiService } from '@cv-invision/core';
// Models
import { CreateOrderFormModel } from '../model/create-order-form.model';
// Others
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class CreateOrderService {
	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService) {
	}

	/**
	 * Create the Order
	 * @param createOrderFormModel
	 */
	public createOrder(createOrderFormModel: CreateOrderFormModel): Observable<any[]> {
		const formData = new FormData();
		formData.append('form', createOrderFormModel.form.form);
		formData.append('schema', createOrderFormModel.form.schema);
		formData.append('file', createOrderFormModel.file);

		return this.httpClient.put(
			this.systemApiService.api.intelligenceService + 'upload/orders/review',
			{params: formData})
			.pipe(
				map((payload: any) => {
					return payload;
				})
			);
	}

}
